import type { AccountAction } from './account-module';
export type SetHydrated = {
  type: 'session/SET_HYDRATED';
  hydrated: boolean;
};
export const setHydrated = (hydrated: boolean): SetHydrated => ({
  type: 'session/SET_HYDRATED',
  hydrated,
});
export type SessionState = {
  fetching: boolean;
  authenticated: boolean;
  initialized: boolean;
  hydrated: boolean;
};
const initialState: SessionState = {
  fetching: true,
  authenticated: false,
  initialized: false,
  hydrated: false,
};
export default function (state: SessionState = initialState, action: AccountAction | SetHydrated): SessionState {
  switch (action.type) {
    case 'account/GET_SUMMARY_SUCCESS': {
      return { ...state, fetching: false, authenticated: Boolean(action.data.account), initialized: true };
    }

    case 'account/GET_SUCCESS': {
      // if the account response was successful - we assume authenticated
      return { ...state, fetching: false, authenticated: true, initialized: true };
    }

    case 'session/SET_HYDRATED': {
      return { ...state, hydrated: action.hydrated };
    }

    default:
      return state;
  }
}
